interface Config {
  webappUrl: string;
  frontDoorUrl: string;
  serverUrl: string;
  serverTimeout: number;
  nodeEnv: string;
  useB2C: boolean;
  clientId?: string;
  authority?: string;
  knownAuthorities?: string[];
  redirectUri?: string;
  navigateToLoginRequestUrl?: boolean;
  elasticSearchHost?: string;
  applicationInsightsConnectionString?: string;
}

let config: Config;

export async function initializeEnvironment(): Promise<Config> {
  if (config) return config; // Return cached config if already initialized

  switch (process.env.NODE_ENV) {
    case "production":
      const response = await fetch("/config.json");
      const serverConfig = await response.json();
      config = {
        ...serverConfig,
        nodeEnv: "production",
      };
      break;
    case "dev1":
      config = {
        webappUrl: "http://localhost:8005",
        serverUrl: "http://localhost:8081",
        frontDoorUrl: "https://docsstorohdatad-eya9f4fafegmc9f5.a03.azurefd.net",
        serverTimeout: 2000,
        nodeEnv: "dev1",
        useB2C: false,
        elasticSearchHost: "https://c4d26d7227df4c778fcc5621d3031d04.eastus.azure.elastic-cloud.com:443",
        applicationInsightsConnectionString: "InstrumentationKey=26c8c870-f4bb-46be-bbd0-9884ea40b478;IngestionEndpoint=https://eastus2-3.in.applicationinsights.azure.com/;LiveEndpoint=https://eastus2.livediagnostics.monitor.azure.com/;ApplicationId=c2c577d1-146e-489f-be35-4b0239d60a40",
      };
      break;
    // case 'devd':
    //     config = {
    //         webappUrl: 'http://localhost:8005',
    //         serverUrl: 'http://localhost:8081',
    //         frontDoorUrl: 'https://docsstorohdatad-eya9f4fafegmc9f5.a03.azurefd.net',
    //         serverTimeout: 2000,
    //         nodeEnv: 'devd',
    //         useB2C: true,
    //         clientId: 'f94bac3c-316f-46c2-8d56-72aa2769e860',
    //         authority: 'https://openhgappdev.b2clogin.com/openhgappdev.onmicrosoft.com/B2C_1_SignIn',
    //         knownAuthorities: ['openhgappdev.b2clogin.com'],
    //         redirectUri: 'http://localhost:8005',
    //         navigateToLoginRequestUrl: true,
    //         elasticSearchHost: 'https://c4d26d7227df4c778fcc5621d3031d04.eastus.azure.elastic-cloud.com:443',
    //         applicationInsightsConnectionString: 'InstrumentationKey=26c8c870-f4bb-46be-bbd0-9884ea40b478;IngestionEndpoint=https://eastus2-3.in.applicationinsights.azure.com/;LiveEndpoint=https://eastus2.livediagnostics.monitor.azure.com/;ApplicationId=c2c577d1-146e-489f-be35-4b0239d60a40'

    //     };
    //     break;
    // case 'devt':
    //     config = {
    //         webappUrl: 'http://localhost:8005',
    //         serverUrl: 'http://localhost:8081',
    //         frontDoorUrl: 'https://docsstorohdatad-eya9f4fafegmc9f5.a03.azurefd.net',
    //         serverTimeout: 2000,
    //         nodeEnv: 'devt',
    //         useB2C: true,
    //         clientId: 'd79f6384-d1ae-41cc-99f6-2406d7d3fd22',
    //         authority: 'https://openhgappdev.b2clogin.com/openhgappdev.onmicrosoft.com/B2C_1_SignIn',
    //         knownAuthorities: ['openhgappdev.b2clogin.com'],
    //         redirectUri: 'http://localhost:8005',
    //         navigateToLoginRequestUrl: true,
    //         elasticSearchHost: 'https://c4d26d7227df4c778fcc5621d3031d04.eastus.azure.elastic-cloud.com:443',
    //         applicationInsightsConnectionString: 'InstrumentationKey=26c8c870-f4bb-46be-bbd0-9884ea40b478;IngestionEndpoint=https://eastus2-3.in.applicationinsights.azure.com/;LiveEndpoint=https://eastus2.livediagnostics.monitor.azure.com/;ApplicationId=c2c577d1-146e-489f-be35-4b0239d60a40'

    //     };
    //     break;
    // case 'devp':
    //     config = {
    //         webappUrl: 'http://localhost:8005',
    //         serverUrl: 'http://localhost:8081',
    //         frontDoorUrl: 'https://docsstorohdatad-eya9f4fafegmc9f5.a03.azurefd.net',
    //         serverTimeout: 2000,
    //         nodeEnv: 'devp',
    //         useB2C: true,
    //         clientId: 'd049a9e8-492b-4faa-a77f-bc7224142a51',
    //         authority: 'https://ohgappb2c.b2clogin.com/ohgappb2c.onmicrosoft.com/B2C_1_SignIn',
    //         knownAuthorities: ['ohgappb2c.b2clogin.com'],
    //         redirectUri: 'http://localhost:8005',
    //         navigateToLoginRequestUrl: true,
    //         elasticSearchHost: 'https://c4d26d7227df4c778fcc5621d3031d04.eastus.azure.elastic-cloud.com:443',
    //         applicationInsightsConnectionString: 'InstrumentationKey=26c8c870-f4bb-46be-bbd0-9884ea40b478;IngestionEndpoint=https://eastus2-3.in.applicationinsights.azure.com/;LiveEndpoint=https://eastus2.livediagnostics.monitor.azure.com/;ApplicationId=c2c577d1-146e-489f-be35-4b0239d60a40'

    //     };
    //     break;
  }
  return config;
}

// Synchronous getter for use after initialization
export function getEnvironment(): Config {
  if (!config) {
    throw new Error("Environment not initialized. Call initializeEnvironment() first.");
  }
  return config;
}
